import type { ConnectedPosition } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';

import type {
  OverlayPosition,
  ListMenuController,
  ListMenuControllerCallbacks,
} from '@core/prosemirror-legacy';
import { WysiwygComponentPortalService } from '@core/prosemirror-legacy/angular';

import { ListMenuComponent } from './list-menu.component';

@Injectable()
export class ListMenuService
  extends WysiwygComponentPortalService<ListMenuComponent>
  implements ListMenuController
{
  protected overlayConfig = {
    hasBackdrop: true,
    backdropClass: 'cdk-overlay-transparent-backdrop',
  };

  public open(position: OverlayPosition | DOMRect, callbacks: ListMenuControllerCallbacks) {
    const preferredPositions: ConnectedPosition[] = [
      { originX: 'center', originY: 'top', overlayX: 'center', overlayY: 'bottom' },
    ];
    this.close();
    this.openComponent(ListMenuComponent, position, preferredPositions, {
      skipComponentCD: true,
    });
    const { instance, location } = this.componentRef!;
    instance.close = () => {
      this.close();
    };
    instance.setCallbacks(callbacks);
    this.componentRef?.changeDetectorRef?.detectChanges();
    return {
      element: <HTMLElement>location.nativeElement,
      backdropClick$: this.overlayRef!.backdropClick(),
    };
  }

  public refresh() {
    this.componentRef?.changeDetectorRef.detectChanges();
  }
}
